// Mapeia o id de cada item do action-center para uma rota de LISTA existente.
// Só os domínios que têm lista no CMS são navegáveis ("Ver todos").
const ROUTE_MAP = {
  psy_approval_pending_90d: "psychologists.list",
  psy_approved_stripe_pending: "psychologists.list",
  appointments_refund_pending: "appointments.list",
};

// Ícone por id do item (Font Awesome)
const ICON_MAP = {
  psy_approval_pending_90d: "fa-solid fa-user-clock",
  psy_approved_stripe_pending: "fa-solid fa-credit-card",
  subs_past_due: "fa-solid fa-file-invoice-dollar",
  appointments_refund_pending: "fa-solid fa-rotate-left",
  payouts_failed_30d: "fa-solid fa-money-bill-transfer",
  reschedule_pending: "fa-solid fa-calendar-day",
  nf_enotas_cancelled_30d: "fa-solid fa-file-invoice",
  cancellations_today: "fa-solid fa-user-minus",
  push_failed_today: "fa-solid fa-bell",
  open_invoices_orphan: "fa-solid fa-file-circle-question",
};

// Itens que não devem aparecer na tela (inúteis operacionalmente)
const HIDDEN_IDS = ["open_invoices_orphan"];

export default {
  name: "Overview",
  data() {
    return {
      loading: true,
      errored: false,
      critical: [],
      warnings: [],
      updatedAt: null,
      bigNumbers: {},
      bigCards: [
        {
          key: "psy_subscribers",
          label: "Psis assinantes",
          icon: "fa-solid fa-star",
        },
        {
          key: "patients",
          label: "Pacientes",
          icon: "fa-solid fa-user-group",
        },
        { key: "psys", label: "Psicólogos", icon: "fa-solid fa-user-doctor" },
        {
          key: "psys_approved",
          label: "Psis aprovados",
          icon: "fa-solid fa-user-check",
        },
        {
          key: "successful_appointments",
          label: "Sessões concluídas",
          icon: "fa-solid fa-calendar-check",
        },
      ],
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.errored = false;
      // big numbers em paralelo — não bloqueia nem derruba o action center
      this.$dashboardService
        .bigNumbers()
        .then((res) => {
          this.bigNumbers = res.data || {};
        })
        .catch((e) => console.log(e));
      try {
        const res = await this.$dashboardService.actionCenter();
        const data = res.data || {};
        this.critical = this.prepare(data.critical);
        this.warnings = this.prepare(data.warnings);
        this.updatedAt = new Date();
      } catch (e) {
        console.log(e);
        this.errored = true;
      } finally {
        this.loading = false;
      }
    },
    // Esconde count=0, ids ocultos e ordena por count decrescente
    prepare(list) {
      return (list || [])
        .filter((i) => Number(i.count) > 0 && !HIDDEN_IDS.includes(i.id))
        .sort((a, b) => Number(b.count) - Number(a.count));
    },
    // Rota de LISTA (botão "Ver todos") ou null
    linkFor(item) {
      const key = ROUTE_MAP[item.id];
      if (!key) return null;
      const [group, prop] = key.split(".");
      const path = this.$paths[group] && this.$paths[group][prop];
      if (!path) return null;
      const query = {};
      if (item.filter) {
        item.filter.split("&").forEach((pair) => {
          const [k, v] = pair.split("=");
          if (k) query[decodeURIComponent(k)] = decodeURIComponent(v || "");
        });
      }
      return { path, query };
    },
    goToList(item) {
      const to = this.linkFor(item);
      if (to) this.$router.push(to);
    },
    // Avatar (foto do psi se o backend mandar profile_image, senão iniciais)
    avatarFor(name, profileImage) {
      const img =
        profileImage && profileImage !== "1"
          ? `${this.$baseImageUrl}${profileImage}`
          : null;
      const parts = String(name || "").trim().split(/\s+/);
      const initials = (
        (parts[0] ? parts[0][0] : "") +
        (parts.length > 1 ? parts[parts.length - 1][0] : "")
      ).toUpperCase();
      return { img, initials: initials || "?" };
    },
    // Normaliza cada linha do preview conforme o shape daquele id
    previewRows(item) {
      const p = this.$paths;
      const rows = item.preview || [];
      const dt = (v) => (v ? this.$moment(v).format("DD/MM/YY HH:mm") : "");
      const d = (v) => (v ? this.$moment(v).format("DD/MM/YYYY") : "");
      const money = (v) =>
        (Number(v) || 0).toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });

      return rows.map((r, i) => {
        switch (item.id) {
          case "psy_approval_pending_90d":
            return {
              key: i,
              avatar: this.avatarFor(r.name, r.profile_image),
              title: r.name,
              sub: [r.crp ? `CRP ${r.crp}` : null, dt(r.created_at)]
                .filter(Boolean)
                .join(" · "),
              to: `${p.psychologists.detail}/${r.id}`,
            };
          case "psy_approved_stripe_pending":
            return {
              key: i,
              avatar: this.avatarFor(r.name, r.profile_image),
              title: r.name,
              sub: [r.email, r.stripe_id ? "Stripe não apto" : "sem Stripe"]
                .filter(Boolean)
                .join(" · "),
              to: `${p.psychologists.detail}/${r.id}`,
            };
          case "subs_past_due":
            return {
              key: i,
              avatar: this.avatarFor(
                r.user && r.user.name,
                r.user && r.user.profile_image
              ),
              title: r.user && r.user.name ? r.user.name : `Sub #${r.id}`,
              sub: [r.plan && r.plan.title, `vence ${d(r.current_period_end)}`]
                .filter(Boolean)
                .join(" · "),
              to: `${p.subscriptions.detail}/${r.id}`,
            };
          case "appointments_refund_pending":
            return {
              key: i,
              avatar: this.avatarFor(r.patient_name, r.patient_profile_image),
              title: [r.patient_name, r.psy_name].filter(Boolean).join(" → "),
              sub: [d(r.date), money(r.value)].filter(Boolean).join(" · "),
              to: `${p.appointments.detail}/${r.id}`,
            };
          case "payouts_failed_30d":
            return {
              key: i,
              avatar: this.avatarFor(r.user_name, r.user_profile_image),
              title: r.user_name || `Payout #${r.id}`,
              sub: [money(r.amount), r.failure_code].filter(Boolean).join(" · "),
              to: `${p.psychologists.detail}/${r.user_id}`,
            };
          case "reschedule_pending":
            return {
              key: i,
              avatar: this.avatarFor(r.requested_by, r.requested_by_profile_image),
              title: r.requested_by || `Sessão #${r.appointment_id}`,
              sub: [`nova data ${dt(r.new_date)}`, dt(r.created_at)]
                .filter(Boolean)
                .join(" · "),
              to: `${p.appointments.detail}/${r.appointment_id}`,
            };
          case "nf_enotas_cancelled_30d":
            return {
              key: i,
              avatar: null,
              title: `NF ${r.invoice_number}`,
              sub: [money(r.invoice_value), r.invoice_status_reason]
                .filter(Boolean)
                .join(" · "),
              to: null,
            };
          default:
            return { key: i, avatar: null, title: JSON.stringify(r), sub: "", to: null };
        }
      });
    },
    goToDetail(row) {
      if (row.to) this.$router.push(row.to);
    },
    updatedLabel() {
      if (!this.updatedAt) return "";
      return this.$moment(this.updatedAt).format("HH:mm");
    },
    iconFor(id) {
      return ICON_MAP[id] || "fa-solid fa-circle-info";
    },
    formatCount(v) {
      return (Number(v) || 0).toLocaleString("pt-BR");
    },
  },
};
